import React from "react";
import { MenuItem, Select, FormControl, Box, Typography } from "@mui/material";
import { addCallOptions } from "../../../../../leads/lead-filter/lead-filter.constant";
import { dropDownProps } from "../campaign-view-details-view-attachment-info/campaign-view-details-view-attachment-info.props";

const AddNewCallDropdown: React.FC<dropDownProps> = ({
  selectedOption,
  handleChange,
  disabled = false,
}) => {
  return (
    <FormControl fullWidth className="upload-dropdown">
      <Select
        displayEmpty
        value={selectedOption}
        onChange={handleChange}
        disabled={disabled}
        renderValue={(selectedVal) => {
          if (!selectedVal) {
            return <span className="placeholder">Add New</span>;
          }
          const selected = addCallOptions.find(
            (opt) => opt.value === selectedVal
          );
          return selected?.label || "";
        }}
      >
        {addCallOptions?.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

              <Typography className="option-text">{option.label}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default AddNewCallDropdown;
